import { HeroSection } from '@/components/sections/HeroSection';
import { ServicesPreview } from '@/components/sections/ServicesPreview';
import { UseCasesSection } from '@/components/sections/UseCasesSection';
import { PricingPreview } from '@/components/sections/PricingPreview';
import { SocialProofSection } from '@/components/sections/SocialProofSection';
import { TestimonialsSection } from '@/components/sections/TestimonialsSection';
import { CTASection } from '@/components/sections/CTASection';
import { SEO } from '@/components/seo/SEO';
import { useLanguage } from '@/context/LanguageContext';

const seoContent = {
  nl: {
    title: 'Website laten maken voor zelfstandigen & KMO\'s',
    description: 'Netblitz bouwt professionele websites voor ondernemers in België. Snel, betaalbaar en SEO-geoptimaliseerd. Vanaf €599. Vraag vandaag een gratis offerte aan.',
    keywords: 'website laten maken, webdesign België, professionele website, webshop, SEO, Brussel, zelfstandigen, KMO, betaalbaar'
  },
  en: {
    title: 'Professional Websites for Freelancers & SMEs',
    description: 'Netblitz builds professional websites for entrepreneurs in Belgium. Fast, affordable and SEO-optimized. From €599. Request a free quote today.',
    keywords: 'website development, web design Belgium, professional website, webshop, SEO, Brussels, freelancers, SME, affordable'
  },
  fr: {
    title: 'Création de sites web pour indépendants & PME',
    description: 'Netblitz crée des sites web professionnels pour les entrepreneurs en Belgique. Rapide, abordable et optimisé SEO. À partir de 599€. Demandez un devis gratuit.',
    keywords: 'création site web, web design Belgique, site professionnel, webshop, SEO, Bruxelles, indépendants, PME, abordable'
  },
  de: {
    title: 'Professionelle Websites für Selbstständige & KMU',
    description: 'Netblitz erstellt professionelle Websites für Unternehmer in Belgien. Schnell, erschwinglich und SEO-optimiert. Ab 599€. Fordern Sie heute ein kostenloses Angebot an.',
    keywords: 'Website erstellen, Webdesign Belgien, professionelle Website, Webshop, SEO, Brüssel, Selbstständige, KMU, günstig'
  }
};

const HomePage = () => {
  const { language } = useLanguage();
  const seo = seoContent[language] || seoContent.nl;

  return (
    <main data-testid="home-page">
      <SEO 
        title={seo.title}
        description={seo.description}
        keywords={seo.keywords}
      />
      {/* Hero - Dark section */}
      <HeroSection />
      
      {/* Waarom Netblitz - Light section */}
      <ServicesPreview />
      
      {/* Voor wie - White section */}
      <UseCasesSection />
      
      {/* Prijzen - Light section */}
      <PricingPreview />
      
      {/* Hosting & Support - Light section */}
      <SocialProofSection />
      
      {/* Reviews */}
      <TestimonialsSection />
      
      {/* CTA - Teal section */}
      <CTASection />
    </main>
  );
};

export default HomePage;
